import { queryOptions } from "@tanstack/react-query";

import { ContentListOptions, contentService } from "./service";

export const contentListQuery = (options?: ContentListOptions) =>
  queryOptions({
    queryKey: options?.compilationId
      ? ["content", "list", options.compilationId, options.sort ?? "default"]
      : ["content", "list"],
    queryFn: ({ signal }) =>
      contentService.getAllContentPreviews(options, { signal }),
  });

export const contentDetailQuery = (idOrSlug: string) =>
  queryOptions({
    queryKey: ["content", "detail", idOrSlug],
    queryFn: ({ signal }) =>
      contentService.getContentByIdOrSlug(idOrSlug, { signal }),
  });
